import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { AppBar } from '@material-ui/core';
import { StyledTabs, StyledTab } from 'components/CustomTab';
import useStyles from './styles';
import useRouter from 'utils/useRouter';

const CommonTabs = ({ value, tabs }) => {
  const classes = useStyles();
  const router = useRouter();

  const handleTabChange = (event, newValue) => {
    const target = tabs.find(t => t.value === newValue);
    if (target && target.to) {
      router.history.push(target.to);
    }
  };

  return (
    <AppBar position="static" className={classes.appbar}>
      <StyledTabs value={value} onChange={handleTabChange} aria-label="tabs" className={classes.tabsContainer}>
        {tabs.map(tab => (
          <StyledTab
            key={tab.value}
            value={tab.value}
            className={classes.tabContainer}
            label={<FormattedMessage id={tab.labelId} />}
          />
        ))}
      </StyledTabs>
    </AppBar>
  );
};

CommonTabs.propTypes = {
  value: PropTypes.string,
  tabs: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    labelId: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
  })).isRequired,
};

export default CommonTabs;

